import { hashKey } from '@tanstack/react-query';
import { matchRoutePattern } from '@/ws/fallback/matchRoutePattern';
import { WsFallbackConfig } from '@/ws/fallback/types';

function namedParams(params: Record<string, string | undefined> | undefined) {
  if (!params) return params;
  const { '*': _splat, ...rest } = params;
  return rest;
}

export function resolveFallbackSignature(config: WsFallbackConfig, pathname: string): string {
  const routeMatch = matchRoutePattern(config.routeQueries, pathname);
  const customMatch = config.customRefetchers ? matchRoutePattern(config.customRefetchers, pathname) : undefined;

  return hashKey([
    routeMatch?.pattern,
    namedParams(routeMatch?.params),
    customMatch?.pattern,
    namedParams(customMatch?.params),
  ]);
}
